module.exports = __webpack_public_path__ + "img/div2s.7c44bf44.jpg";